const ua = window.navigator.userAgent;

export const isAndroid =
  ua.indexOf("Android") > -1 &&
  ua.search(/Chrome\/[.0-9]* (Mobile )?Safari/g) > -1;
